import {VtCorridorCalculationService} from "./vt-corridor-calculation-service";
import {QuoteService} from "quote-domain-core";
import {VtCorridorCalculator} from "./vt-corridor-calculator";
import {singleton} from "tsyringe";

@singleton()
export class VtCorridorCalculatorFactory {

    constructor(
        private readonly corridorCalculationService: VtCorridorCalculationService
    ) {}

    create(
        quoteService: QuoteService,
        referential: any,
        referentialService: any,
        region: string
    ): VtCorridorCalculator {

        return new VtCorridorCalculator(
            quoteService,
            referential,
            referentialService,
            region,
            this.corridorCalculationService
        );
    }
}